import styled from '@mint-lib/styled';
import LinearProgressM, {
  linearProgressClasses,
  LinearProgressProps as LinearProgressPropsM,
} from '@mui/material/LinearProgress';

import Box from '../Box/Box.jsx';
import Typography from '../Typography/Typography.jsx';

const MAX_VALUE = 100;

export interface LinearProgressProps extends LinearProgressPropsM {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes?: LinearProgressPropsM['classes'];
  /**
   * @ignore
   */
  className?: string;
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color?: LinearProgressPropsM['color'];
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value?: number;
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer?: number;
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant?: LinearProgressPropsM['variant'];
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the `sx` page for more details. https://mui.com/system/the-sx-prop/
   */

  sx?: LinearProgressPropsM['sx'];
  /**
   * if true, LinearProgress will be with label
   */
  withLabel?: boolean;
  /**
   * Custom label
   */
  customLabel?: number;
}

export default LinearProgress;

/**
 * @deprecated Use ProgressLinear from @mint-lib/tw-components/patterns instead
 */
function LinearProgress({
  withLabel,
  value = 0,
  customLabel,
  color = 'primary',

  ...props
}: LinearProgressProps) {
  const currenValue = value > MAX_VALUE ? MAX_VALUE : value;

  return (
    <OuterContainer>
      <ProgressContainer>
        <StyledLinearProgress value={currenValue} color={color} {...props} />
      </ProgressContainer>
      {withLabel && value ? (
        <TypographyContainer>
          <Typography variant="caption01" color="text.secondary">{`${Math.round(
            customLabel ? customLabel : value,
          )}%`}</Typography>
        </TypographyContainer>
      ) : null}
    </OuterContainer>
  );
}

const TypographyContainer = styled(Box)({
  minWidth: '35px',
  display: 'flex',
});
const ProgressContainer = styled(Box)({
  width: '100%',
  marginRight: '0.5rem',
});
const OuterContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

const StyledLinearProgress = styled(LinearProgressM)(({ theme }) => ({
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.greyscale.grey20,
    strokeLinecap: 'round',
    borderRadius: '4px',
  },
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: theme.palette.tertiary.light,
  },
}));
